import { render, staticRenderFns } from "./addresindic.vue?vue&type=template&id=5278f9b7&scoped=true&"
import script from "./addresindic.vue?vue&type=script&lang=js&"
export * from "./addresindic.vue?vue&type=script&lang=js&"
import style0 from "./addresindic.vue?vue&type=style&index=0&id=5278f9b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278f9b7",
  null
  
)

export default component.exports